import FlashLib from "flashlib";

export default class DecorationsContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);
    }

    changeState(value) {
        this.goToFrame(value);
    }
}